import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "info-1",
  "use": "info-1-usage",
  "viewBox": "0 0 512 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 1024\" id=\"info-1\"><path d=\"M128 96c0-51.2 44.8-96 96-96h64c51.2 0 96 44.8 96 96v64c0 51.2-44.8 96-96 96h-64c-51.2 0-96-44.8-96-96V96zm384 928H0V896h128V512H0V384h384v512h128v128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/info-1.svg
// module id = Ph1b
// module chunks = 1